import { useGetNotesQuery } from '@carboncopyco/data';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { FilledNoteIcon, NotesIcon } from '@carboncopyco/icons';
import type { NoteEntityType } from '@carboncopyco/types';

type SpeakerNotesIconProps = {
  organizationId: string;
  entityType: NoteEntityType;
  entityId: string;
};

export const SpeakerNotesIcon = ({
  organizationId,
  entityType,
  entityId,
}: SpeakerNotesIconProps) => {
  const flags = useFlags();
  const { data: notes } = useGetNotesQuery(
    {
      organizationId,
      entityType,
      entityId,
    },
    { skip: !flags.speakerNotes }
  );
  const note = notes?.[0]?.content;

  return note ? <FilledNoteIcon size={18} /> : <NotesIcon size={18} />;
};
